import React from "react";
import { CardActionArea, Typography } from "@mui/material";
import lazyLoadIfNeeded from "../FadeIn";

const EventCardHeader = ({ title, img, handleExpandClick, expanded }) => {
  const checkAndFixImage = (img) => {
    return (
      img?.url ||
      "https://desdaklimrek.science.ru.nl/wp-content/uploads/desda_kaartje9.png"
    );
  };

  return (
    <CardActionArea>
      <div
        className={"EventCard-imageDiv"}
        onClick={expanded ? null : handleExpandClick}
      >
        {lazyLoadIfNeeded(
          title,
          checkAndFixImage(img),
          "EventCard-image",
          true,
          handleExpandClick,
        )}
        <Typography variant="h6" component="h1" noWrap className="card-title">
          {title}
        </Typography>
      </div>
    </CardActionArea>
  );
};

export default EventCardHeader;
